import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Head from '../head';
import Feed from '../feed';
import styles from './index.css';

class Column1 extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            columnHead3,
            columnFeed3
        } = this.props.content;

        return (
            <div className={styles.column2}>
                <Chip id="261076" type="struct" title="圖集標題" groupName="圖集" content={columnHead3} >
                    <Head />
                </Chip>
                <Chip id="289035" type="recommend" title="圖集推薦位" groupName="圖集" content={columnFeed3} >
                    <Feed />
                </Chip>
            </div>
        );
    }
}

export default Column1;
